import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'MicrosoftLogo',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_659_23922)\"><path d=\"M0.762207 0.832031H17.7622V17.832H0.762207V0.832031Z\" fill=\"#F3F3F3\"></path><path d=\"M1.50146 1.57031H8.89277V8.96162H1.50146V1.57031Z\" fill=\"#F35325\"></path><path d=\"M9.63184 1.57031H17.0231V8.96162H9.63184V1.57031Z\" fill=\"#81BC06\"></path><path d=\"M1.50146 9.70117H8.89277V17.0925H1.50146V9.70117Z\" fill=\"#05A6F0\"></path><path d=\"M9.63184 9.70117H17.0231V17.0925H9.63184V9.70117Z\" fill=\"#FFBA08\"></path></g><defs><clipPath id=\"clip0_659_23922\"><rect width=\"17\" height=\"17\" fill=\"white\" transform=\"translate(0.762207 0.832031)\"></rect></clipPath></defs>", 2)
  ]), 2))
}
}

})